import { attachLocale, trackAnalyticsNew } from '../../../../lib/utils';
import { DATA_TRACK_TYPE_INTERNAL } from '../../../../lib/constants';

export const MY_ZONE_SHOP_TRACKING_LOCATION = 'page:header-nav:level-2:my-zone:';

export const getMyZoneUtilityLinkProps = ({ analyticsSlug, url, locale }) => {
  const track = trackAnalyticsNew({
    name: analyticsSlug,
    location: 'page:header-nav:level-2:my-zone',
    url: attachLocale(url, locale),
  });

  return {
    id: track.dataTrackingId,
    'data-track-id': track.dataTrackingId,
    'data-track-click': track.dataTrack,
    'data-track-type': DATA_TRACK_TYPE_INTERNAL,
    href: track.url,
  };
};
